import type React from 'react';

const IconVisa: React.FC = () => (
  <svg
    width="62px"
    height="39px"
    viewBox="0 0 62 39"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Visa_card</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Payment-"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Make-a-payment-basic-Copy"
        transform="translate(-325.000000, -483.000000)"
        fillRule="nonzero"
      >
        <g id="Group-7" transform="translate(205.000000, 339.000000)">
          <g id="Group-6" transform="translate(30.000000, 78.000000)">
            <g id="Visa_card" transform="translate(90.000000, 66.000000)">
              <path
                d="M61.49985,37.3672065 L61.49985,1.633914 C61.49985,1.00451328 61.0052076,0.50005 60.4003525,0.50005 L1.59985,0.50005 C0.994819978,0.50005 0.49985,1.00468622 0.49985,1.633914 L0.49985,37.3672065 C0.49985,37.9955515 0.994949287,38.50005 1.59985,38.50005 L60.4003525,38.50005 C61.0050785,38.50005 61.49985,37.9957245 61.49985,37.3672065 Z"
                id="Fill-1"
                stroke="#D6D6D6"
                fill="#F7F7F7"
              />
              <polygon
                id="Fill-4"
                fill="#0066B2"
                points="28.3606 24.98595 25.2976 24.98595 27.2121 13.21845 30.2761 13.21845"
              />
              <path
                d="M22.71975,13.2186 L19.79925,21.3121 L19.45325,19.5696 L19.45325,19.5701 L18.42225,14.2781 C18.42225,14.2781 18.29825,13.2186 16.96925,13.2186 L12.14075,13.2186 L12.08425,13.4181 C12.08425,13.4181 13.56125,13.7246 15.28975,14.7631 L17.95075,24.9861 L21.14275,24.9861 L26.01725,13.2186 L22.71975,13.2186 Z"
                id="Fill-6"
                fill="#0066B2"
              />
              <path
                d="M43.4463,20.82385 L45.0558,16.41935 L45.9618,20.82385 L43.4463,20.82385 Z M46.8173,24.98585 L49.6303,24.98585 L47.1778,13.21885 L44.7153,13.21885 C43.5778,13.21885 43.3003,14.09535 43.3003,14.09535 L38.7313,24.98585 L41.9248,24.98585 L42.5633,23.23835 L46.4578,23.23835 L46.8173,24.98585 Z"
                id="Fill-8"
                fill="#0066B2"
              />
              <path
                d="M38.97095,16.0482 L39.40795,13.5212 C39.40795,13.5212 38.05845,13.0082 36.65295,13.0082 C35.13195,13.0082 31.52195,13.6732 31.52195,16.9037 C31.52195,19.9442 35.75995,19.9822 35.75995,21.5782 C35.75995,23.1742 31.95895,22.8892 30.70395,21.8822 L30.24845,24.5237 C30.24845,24.5237 31.61645,25.1887 33.70695,25.1887 C35.79695,25.1887 38.95195,24.1057 38.95195,21.1602 C38.95195,18.1007 34.67645,17.8152 34.67645,16.4857 C34.67645,15.1547 37.65995,15.3257 38.97095,16.0482"
                id="Fill-10"
                fill="#0066B2"
              />
              <path
                d="M19.45315,19.56995 L18.42215,14.27845 C18.42215,14.27845 18.29815,13.21845 16.96915,13.21845 L12.14065,13.21845 L12.08465,13.41795 C12.08465,13.41795 14.40565,13.89895 16.63165,15.70045 C18.76015,17.42345 19.45315,19.56995 19.45315,19.56995"
                id="Fill-12"
                fill="#F9A533"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IconVisa;
